const _import = require("../_import");
import Layout from "@/page/index/";

export default [
  {
    path: "/components",
    component: Layout,
    redirect: "/components/table",
    children: [
      // {
      //   path: 'foreign_consular_management',
      //   name: '领事认证管理',
      //   component: _import('foreign_consular_management/consular_certification_management', 'views')
      // }
    ]
  },
  {
    path: "/cockpit",
    name: "驾驶舱首页",
    component: _import("cockpit/index", "views")
  },
  {
    path: "/test",
    name: "test",
    component: _import("workflow/test", "views")
  }
];
